import Swiper from "swiper";

export default class Overons {
    constructor() {
        if(document.querySelector('#overons')){
            this.employees();
        }
    }

    employees() {
        const swiper = new Swiper('#overons #content .swiper-container', {
            slidesPerView: 1,
            spaceBetween: 16,
            breakpoints: {
                576: {
                    slidesPerView: 3,
                }
            }
        });
    }
}
